export const manifest = [
  {
    title: "Perhaps the best ROI of any item",
    canonTitle: "best-roi-of-any-item",
    mdSrc: "/best_roi.md",
    imgSrc: "/best_roi.png",
    imgAlt: "Eugene Oasis products",
    previewText: `Perhaps the best ROI of any promotional product. Make sure your guest remembers the name of your space! Add a QR code to the listing or social media sites. Useful for generating...`,
    date: "Mar 01, 2022",
  },
  {
    title: "Custom Items create better experiences",
    canonTitle: "custom-items-create-better-experiences",
    mdSrc: "/custom_items.md",
    imgSrc: "/custom_items.png",
    imgAlt: "Eugene cascades image",
    previewText: `Personalization is one of the surest ways to improve your guest experience. The more you can customize a stay, the more welcome and appreciated that guest will feel. Adding custom...`,
    date: "May 23, 2022",
  },
];
